import React from "react"
import "./DisclaimerPage.css"

const DisclaimerPage = () => {
  return (
    <div className="epw-disclaimer-page">

      <main>
        <header className="epw-disclaimer-hero">
          <div className="epw-wrap">
            <p className="epw-eyebrow">EnergyPulseWorld</p>
            <h1>Disclaimer</h1>
            <p>
              This page explains how EnergyPulseWorld prepares its analysis,
              compiles information from third-party sources, and presents
              reported, derived, provisional and estimated data.
            </p>
          </div>
        </header>

        <section className="epw-disclaimer-main">
          <div className="epw-wrap">

            <div className="epw-notice">
              <strong>In summary:</strong>{" "}
              EnergyPulseWorld produces original analysis, summaries, tables,
              charts and visualizations using information drawn from public,
              official and other recognized sources. Third-party sources are
              cited for informational purposes and do not imply review,
              approval or endorsement of EnergyPulseWorld's analysis.
            </div>

            <section className="epw-section">
              <h2>1. Nature of EnergyPulseWorld Analysis</h2>
              <p>
                EnergyPulseWorld publications, dashboards, country profiles,
                charts, tables, infographics and weekly reports contain analysis
                prepared by EnergyPulseWorld based on the compilation,
                interpretation and comparison of information from multiple sources.
              </p>
              <p>
                The resulting analysis, commentary, classifications, comparisons
                and visualizations represent EnergyPulseWorld's own analytical
                synthesis unless expressly stated otherwise.
              </p>
            </section>

            <section className="epw-section">
              <h2>2. Sources of Information</h2>
              <p>
                EnergyPulseWorld draws on a broad range of publicly available,
                official and recognized sources, which may include:
              </p>
              <ul>
                <li>International organizations and multilateral institutions</li>
                <li>National statistical offices and government authorities</li>
                <li>Energy ministries, regulators and system operators</li>
                <li>Customs and trade administrations</li>
                <li>Market and commodity data providers</li>
                <li>Company disclosures and industry publications</li>
                <li>Established financial, business and international news sources</li>
              </ul>
              <p>
                Source references are provided where relevant to allow users to
                understand the basis of the information and analysis presented.
              </p>
            </section>

            <section className="epw-section">
              <h2>3. Compilation, Transformation and Interpretation</h2>
              <p>
                Information obtained from third-party sources may be compiled,
                standardized, converted, categorized, compared, summarized or
                combined with other information in order to support cross-country,
                regional or time-series analysis.
              </p>
              <p>
                EnergyPulseWorld may also calculate trends, percentage changes,
                benchmarks, regional comparisons or other derived indicators from
                underlying reported data. Accordingly, a chart, table or analytical
                conclusion published by EnergyPulseWorld may not appear in the same
                form in any individual source.
              </p>
            </section>

            <section className="epw-section">
              <h2>4. Estimates, Provisional and Derived Data</h2>
              <p>
                Official data are not always available at the same frequency or
                with the same publication delay across countries and markets.
                Where appropriate, EnergyPulseWorld may therefore use provisional,
                derived, benchmark or estimated values to provide more current
                analytical visibility.
              </p>
              <p>
                Such values are identified where relevant and should not be
                interpreted as validated historical figures unless explicitly
                described as such. Estimates may be revised when newer or more
                authoritative information becomes available.
              </p>
            </section>

            <section className="epw-section">
              <h2>5. Accuracy, Timeliness and Completeness</h2>
              <p>
                EnergyPulseWorld takes reasonable care in selecting sources and
                reviewing the information used in its analysis. However, data may
                be revised, delayed, incomplete, inconsistent across sources or
                subsequently corrected by the original publisher.
              </p>
              <p>
                EnergyPulseWorld therefore does not warrant that all information is
                complete, error-free or current at all times. Users should consider
                the publication date, data period and source methodology when using
                the information for decision-making.
              </p>
            </section>

            <section className="epw-section">
              <h2>6. Country and Trade Indicators</h2>
              <p>
                Country-level trade, customs, licensing, tariff, clearance-time and
                administrative indicators are intended as comparative or indicative
                benchmarks. They may not reflect the exact requirements applicable
                to a particular product, shipment, importer or transaction.
              </p>
              <p>
                Actual conditions may vary depending on factors including product
                classification, country of origin, preferential arrangements,
                end use, standards, licensing requirements, customs procedures and
                applicable trade measures.
              </p>
            </section>

            <section className="epw-section">
              <h2>7. Third-Party Sources and No Endorsement</h2>
              <p>
                References to third-party organizations, databases, publications
                or news sources are provided for attribution and informational
                purposes only.
              </p>
              <p>
                Unless expressly stated otherwise, no third-party source has
                reviewed, approved or endorsed EnergyPulseWorld's analysis,
                conclusions, charts, tables or other content. Likewise,
                EnergyPulseWorld's citation of a source does not imply endorsement
                of that source's broader views or activities.
              </p>
            </section>

            <div className="epw-highlight">
              <h2>Important distinction</h2>
              <p>
                A citation identifies the information used in preparing the
                analysis. The interpretation, synthesis and conclusions presented
                by EnergyPulseWorld remain those of EnergyPulseWorld unless a
                statement is expressly attributed to another organization or source.
              </p>
            </div>

            <section className="epw-section">
              <h2>8. Informational Use Only</h2>
              <p>
                EnergyPulseWorld content is provided for general informational,
                analytical and research purposes. It does not constitute investment,
                financial, legal, tax, regulatory, customs or other professional advice.
              </p>
              <p>
                Users should obtain appropriate professional advice and independently
                verify material information before making investment, commercial,
                regulatory or contractual decisions.
              </p>
            </section>

            <section className="epw-section">
              <h2>9. Updates and Revisions</h2>
              <p>
                EnergyPulseWorld may update, revise or replace data, analysis,
                estimates, charts or commentary as new information becomes available.
                Historical publications may therefore differ from later versions or
                subsequent datasets covering the same period.
              </p>
            </section>

            <section className="epw-contact">
              <h2>Questions about sources or methodology?</h2>
              <p>
                For questions concerning the methodology, source attribution or
                interpretation of EnergyPulseWorld data, please use the contact
                form available on <a href="/contact">EnergyPulseWorld.com</a>.
              </p>
            </section>

            <p className="epw-updated">
              Last updated: September 2026.
            </p>

          </div>
        </section>
      </main>
    </div>
  )
}

export default DisclaimerPage
